import { IconPhotoPlus } from "@tabler/icons-react";
//import { PlusCircleIcon, PlusIcon } from "@heroicons/react/24/outline";
import withIconSize from "./hoc/withIconSize";
import { InternalIconProps } from "./types/SvgIconProps";

interface Props extends InternalIconProps {
  className?: string;
}

const AppImageGroupFieldIcon = (props: Props) => {
  const { className, ...rest } = props;

  return <IconPhotoPlus {...rest} className={props.className} />;
};
export default withIconSize(AppImageGroupFieldIcon);
